export enum LocationSearchType {
  DEFAULT = 'default',
  CUSTOM_SEARCH = 'custom-search',
  SHARE_MY_LOCATION = 'share-my-location',
}
